/**
 * Order Formatting Utilities
 * Shared helpers for displaying order IDs and related formatting.
 */

/**
 * Convert a raw order ID to a customer-friendly display reference.
 * TSS-2026-0024 → #26-0024
 * Non-TSS IDs are returned as-is.
 */
export function getDisplayOrderRef(orderId: string | undefined | null): string {
  if (!orderId) return 'N/A';
  if (!orderId.startsWith('TSS-')) return orderId;
  const parts = orderId.replace('TSS-', '').split('-');
  return `#${parts[0].slice(-2)}-${parts[1]}`;
}
